import { IconButtonProps } from './IconButton.types';
import { TBaseButtonChildrenProps } from '../base-button/BaseButton.types';
import { forwardRef } from 'react';
import { BaseButton } from '../base-button/BaseButton';
import { ButtonIconChild } from '../base-button-children/button-icon-child/ButtonIconChild';

export const IconButton = forwardRef(
  (
    {
      accessibilityLabel: accessibilityLabelProp,
      iconName,
      iconStyle,
      iconDisabledStyle,
      iconFocusStyle,
      iconHoverStyle,
      iconPressedStyle,
      iconTestID,
      ...buttonProps
    }: IconButtonProps,
    ref,
  ) => {
    const accessibilityLabel = accessibilityLabelProp ?? `${iconName} Icon Button`;

    return (
      <BaseButton ref={ref} accessibilityLabel={accessibilityLabel} {...buttonProps}>
        {(baseButtonChildrenProps: TBaseButtonChildrenProps) => {
          return (
            <ButtonIconChild
              {...{
                iconName,
                iconStyle,
                iconDisabledStyle,
                iconFocusStyle,
                iconHoverStyle,
                iconPressedStyle,
                iconTestID,
                ...baseButtonChildrenProps,
              }}
            />
          );
        }}
      </BaseButton>
    );
  },
);

IconButton.displayName = 'IconButton';
